module.exports = __webpack_public_path__ + "img/TrArtist.b891e188.png";